import { useQuery } from "@tanstack/react-query";
import { ToastService } from "@shared/lib/services";
import {
  SocialMediaInfluencer,
  SocialMediaInfluencerRequest,
} from "@shared/lib/types/influencer";
import { BackednResponse } from "@shared/lib/types";
import { InfluencerService } from "../services/influencer.service";
import { SOCIAL_MEDIA_INFLUENCER_QUERY_KEY } from "../constants";

export function useGetSocialMediaInfluencer(
  request: SocialMediaInfluencerRequest
) {
  const { data, isLoading, isError, error, refetch } = useQuery<
    BackednResponse<SocialMediaInfluencer>
  >({
    queryKey: [...SOCIAL_MEDIA_INFLUENCER_QUERY_KEY, request],
    queryFn: () => InfluencerService.getSocialMediaInfluencer(request),
    enabled:
      ("influencerId" in request && !!request.influencerId) ||
      ("socialMediaObjectId" in request && !!request.socialMediaObjectId) ||
      ("username" in request &&
        !!request.username?.platform &&
        !!request.username?.socialMediaUsername),
  });

  const errorMessage = isError && error?.message;
  if (errorMessage) {
    ToastService.error(errorMessage);
  }

  return {
    socialMediaInfluencer: data?.data,
    isFetching: isLoading,
    isError,
    refetch,
  };
}
